







import { Component, Vue } from "vue-property-decorator";

@Component
export default class OverviewFlushCache extends Vue {
  title = "Flush Cache";

  flushCache() {
    if (window.confirm("Clicking OK will remove all the data from your cache. Are you sure you want to do this?")) {
      this.$ga.button(this.title);
      this.$store.dispatch("flushCache");
    }
  }
}
